import { Box, styled, Typography } from '@mui/material';
import { InputStatus } from 'src/components/input/Input.interface';
import { getInputColorField } from 'src/components/input/Input.styled';

export const TextField = styled(Typography)<{ status?: InputStatus }>(
  ({ status, theme }) => `
  font-size: 1rem;
  font-weight: 300;
   ${getInputColorField(status, theme)}
`,
);

export const InputLabel = styled(Typography)(
  () => `
  font-weight: 400;
`,
);

export const Wrapper = styled(Box)(
  () => `
  position: relative;
  width: 50px;

  & p {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    text-align: left;
    margin-top: 3px;
    margin-right: 14px;
    margin-bottom: 0;
    margin-left: 3px;
  }
`,
);
